export default __webpack_public_path__ + "static/Bigcommerce-2358c8afd74b49f951ac5972b0c96a94.png";